module.exports = __webpack_public_path__ + "static/media/VEN.37db6479.png";